import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Shield, Zap, Trophy } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#0a0a0a] overflow-hidden pt-12 pb-20 md:pt-20 md:pb-32" data-id="element-43">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-blue-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-44" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-purple-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-45" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-46">
        <div className="flex flex-col items-center text-center" data-id="element-47">
          {/* Pre-headline Badge */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-bold tracking-wider uppercase mb-8 animate-pulse" data-id="element-48">
            <Trophy className="w-4 h-4" data-id="element-49" />
            🔥 Últimos días de descuento
          </motion.div>

          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] tracking-tight mb-8 max-w-5xl" data-id="element-50">
            DEJÁ DE PERDER PARTIDAS COMO{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500" data-id="element-51">
              ADC
            </span>{' '}
            POR ERRORES QUE SE PUEDEN EVITAR
          </motion.h1>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="relative w-full max-w-lg mx-auto mb-10 group" data-id="element-52">
            <div className="absolute inset-0 bg-gradient-to-b from-blue-500/20 to-purple-500/20 blur-2xl rounded-full opacity-50 group-hover:opacity-75 transition-opacity duration-500" data-id="element-53" />
            <img src="https://cdn.magicpatterns.com/uploads/kqZLZ6nhMB1wH7BDN7J1cm/1d4c12d4-7d3b-4da2-b7fc-ef66f5e652b7.png" alt="Guía Completa de ADC - Libro Digital" className="relative w-full h-auto drop-shadow-[0_0_30px_rgba(59,130,246,0.3)] transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-54" />
          </motion.div>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-xl md:text-2xl text-gray-300 font-medium max-w-3xl mx-auto mb-10 italic border-l-4 border-amber-500 pl-6 py-2 bg-white/5 rounded-r-lg" data-id="element-55">
            "Este no es un libro sobre daño. Es un libro sobre{' '}
            <span className="text-white font-bold" data-id="element-56">decisiones</span>."
          </motion.p>

          {/* Price & CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col items-center gap-6 w-full" data-id="element-57">
            <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6" data-id="element-58">
              <span className="text-2xl text-red-500 font-bold line-through decoration-2 decoration-red-500/50 opacity-80" data-id="element-59">
                $29.999
              </span>
              <span className="text-5xl md:text-6xl font-black text-amber-400 drop-shadow-lg tracking-tight" data-id="element-60">
                $7.999{' '}
                <span className="text-2xl text-amber-200 font-bold" data-id="element-61">ARS</span>
              </span>
            </div>

            <CtaButton subtext="📥 Entrega digital inmediata" className="w-full md:w-[400px] text-lg" data-id="element-62" />

            <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm text-gray-400" data-id="element-63">
              <div className="flex items-center gap-1.5" data-id="element-64">
                <Shield className="w-4 h-4 text-green-500" data-id="element-65" />
                <span data-id="element-66">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-67">
                <Zap className="w-4 h-4 text-amber-500" data-id="element-68" />
                <span data-id="element-69">Acceso Instantáneo</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-70" />
    </section>;
}